/* so topical — mobile carousel for the three-callout section (section_mVgtrT)
 * Below 750px the three group blocks become one-at-a-time slides:
 * swipeable, with arrow + dot controls and a gentle auto-advance that stops
 * as soon as the visitor interacts. Desktop layout is untouched.
 */
(function () {
  var SECTION_SUFFIX = '__section_mVgtrT';
  var MQ = '(max-width: 749px)';
  var INTERVAL = 5000;

  var CSS = [
    '.so-cc__controls{display:none}',
    '@media screen and (max-width:749px){',
    '.so-cc--on .section-content-wrapper{flex-direction:row!important;flex-wrap:nowrap!important;',
    'overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;',
    'scrollbar-width:none;-ms-overflow-style:none;gap:0!important;align-items:flex-start!important}',
    '.so-cc--on .section-content-wrapper::-webkit-scrollbar{display:none}',
    '.so-cc--on .section-content-wrapper > .group-block{flex:0 0 100%!important;width:100%!important;',
    'max-width:100%!important;scroll-snap-align:center;scroll-snap-stop:always}',
    '.so-cc__controls--on{display:flex;align-items:center;justify-content:center;gap:20px;',
    'margin:4px auto 34px;padding:0 16px}',
    '.so-cc__arrow{-webkit-appearance:none;appearance:none;background:none;border:0;padding:8px;margin:0;',
    'line-height:0;cursor:pointer;color:currentColor;opacity:.5;transition:opacity .2s ease}',
    '.so-cc__arrow:hover,.so-cc__arrow:focus-visible{opacity:.9}',
    '.so-cc__arrow svg{display:block;width:16px;height:16px}',
    '.so-cc__dots{display:flex;align-items:center;gap:9px}',
    '.so-cc__dot{-webkit-appearance:none;appearance:none;width:6px;height:6px;padding:0;border:0;',
    'border-radius:50%;background:currentColor;opacity:.22;cursor:pointer;transition:opacity .3s ease}',
    '.so-cc__dot[aria-current="true"]{opacity:.8}',
    '}'
  ].join('');

  function injectCss() {
    if (document.getElementById('so-cc-style')) return;
    var st = document.createElement('style');
    st.id = 'so-cc-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'so-cc__arrow so-cc__arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      (dir === 'prev' ? '<polyline points="15 5 8 12 15 19"/>' : '<polyline points="9 5 16 12 9 19"/>') +
      '</svg>';
    return b;
  }

  function build(root) {
    var track = root.querySelector('.section-content-wrapper');
    if (!track) return null;

    var slides = Array.prototype.filter.call(track.children, function (el) {
      return el.classList.contains('group-block');
    });
    if (slides.length < 2) return null;

    var controls = document.createElement('div');
    controls.className = 'so-cc__controls';

    var prev = arrow('prev');
    var next = arrow('next');
    var dotWrap = document.createElement('div');
    dotWrap.className = 'so-cc__dots';

    var dots = slides.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'so-cc__dot';
      d.setAttribute('aria-label', 'Show item ' + (i + 1) + ' of ' + slides.length);
      dotWrap.appendChild(d);
      return d;
    });

    controls.appendChild(prev);
    controls.appendChild(dotWrap);
    controls.appendChild(next);
    root.parentNode.insertBefore(controls, root.nextSibling);

    var timer = null;
    var stopped = false;
    var raf = null;

    function index() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }

    function paint() {
      var i = index();
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function go(i, smooth) {
      var n = (i + slides.length) % slides.length;
      track.scrollTo({
        left: n * track.clientWidth,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
    }

    function stop() {
      stopped = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (stopped || timer) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        go(index() + 1);
      }, INTERVAL);
    }

    prev.addEventListener('click', function () { stop(); go(index() - 1); });
    next.addEventListener('click', function () { stop(); go(index() + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { stop(); go(i); });
    });
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (evt) {
      track.addEventListener(evt, stop, { passive: true });
    });

    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
    }, { passive: true });

    paint();

    return {
      controls: controls,
      on: function () {
        root.classList.add('so-cc--on');
        controls.classList.add('so-cc__controls--on');
        paint();
        start();
      },
      off: function () {
        root.classList.remove('so-cc--on');
        controls.classList.remove('so-cc__controls--on');
        if (timer) { clearInterval(timer); timer = null; }
        track.scrollLeft = 0;
      }
    };
  }

  function setup() {
    injectCss();

    var root = document.querySelector('[id$="' + SECTION_SUFFIX + '"]');
    if (!root || root.dataset.soCc === 'ready') return;

    Array.prototype.forEach.call(document.querySelectorAll('.so-cc__controls'), function (el) {
      el.parentNode.removeChild(el);
    });

    root.dataset.soCc = 'ready';

    var api = build(root);
    if (!api) return;

    var mq = window.matchMedia(MQ);
    function apply() { mq.matches ? api.on() : api.off(); }
    apply();
    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else {
      mq.addListener(apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id && e.target.id.indexOf(SECTION_SUFFIX) > -1) {
      delete e.target.dataset.soCc;
      setup();
    }
  });
})();
